export const imageSizes = <const>[36, 124, 240, 360, 480, 768, 1024, 1200]
